import { render, staticRenderFns } from "./NotificationPod.vue?vue&type=template&id=c28789b4&scoped=true&"
import script from "./NotificationPod.vue?vue&type=script&lang=js&"
export * from "./NotificationPod.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPod.vue?vue&type=style&index=0&id=c28789b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28789b4",
  null
  
)

export default component.exports